import { computed } from '@angular/core';
import {
  getState,
  patchState,
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import {
  BrowserDataFieldsEnum,
  BrowserDataStateInterface,
} from './browser-data.interface';

const initialState: BrowserDataStateInterface = {
  [BrowserDataFieldsEnum.cookieAcceptValues]: null,
  [BrowserDataFieldsEnum.authenticated]: null,
};

export type BrowserDataStore = InstanceType<typeof BrowserDataStore>;

export const BrowserDataStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ cookieAcceptValues }) => ({
    analyticsEnabled: computed(
      () =>
        !cookieAcceptValues?.() ||
        cookieAcceptValues?.()?.allCookies ||
        cookieAcceptValues?.()?.analyticsCookies,
    ),
  })),
  withMethods((store) => ({
    saveAuthenticated(authenticated: boolean): void {
      patchState(store, { authenticated });
      localStorage.setItem(
        BrowserDataFieldsEnum.authenticated,
        authenticated.toString(),
      );
    },
    _isJsonObject(data: string): boolean {
      try {
        const newJson = JSON.parse(data);
        return (typeof newJson === 'object' && newJson !== data) || false;
      } catch (e) {
        return false;
      }
    },
  })),
  withHooks({
    onInit(store): void {
      patchState(
        store,
        Object.keys(BrowserDataFieldsEnum).reduce((acc, curr) => {
          const item = localStorage.getItem(curr);

          if (item) {
            return {
              ...acc,
              [curr]: JSON.parse(item),
            };
          } else {
            return acc;
          }
        }, getState(store)),
      );
    },
  }),
);
